import { Typography, ButtonBase, Icon } from '@material-ui/core';
import styled from 'styled-components';
import { PageHeader } from 'components';
import { useSyncBlueDriverVehiclesMutation } from 'services/api/admin-vehicle-history';
import { useDispatch } from 'react-redux';
import { VinScanButton } from '../VinScan';
import { useDeviceInfo } from 'hooks/useDeviceInfo';
import { usePoolModalControls } from 'services/listVehiclesSlice/listVehiclesSlice';
import SyncIcon from 'img/sync.svg';
import VehiclePoolDialog from 'components/ListVehicles/VehiclePoolDialog';
import { openVinDialog } from 'services/listerUploadVehicle/v2';
import { VinDialog } from 'components/ListVehicles/components/CreateVehicleDialog/VinDialog';
import { useCurrentUser } from 'hooks/selectors';
import { FilterButton } from './FilterButton';
import { ActionButton } from './ui';
import { useHeaderContext, VehicleListHeaderContextProvider } from './context';
import { useVehicleListContext } from '../../context';

const StyledTypography = styled(Typography)`
  && {
    font-weight: 500;
    font-size: 16px;
    padding: 23px 13px;
  }
`;

const StyledPageHeader = styled(PageHeader)`
  margin-bottom: ${props => (props.mobile ? 0 : '16px')};
  z-index: 1;
`;

const HeaderWithContext = () => {
  return (
    <VehicleListHeaderContextProvider>
      <Header />
    </VehicleListHeaderContextProvider>
  );
};

const Header = () => {
  const { isMobile } = useDeviceInfo();
  const { mobileFiltersOpened } = useHeaderContext();

  return (
    <StyledPageHeader
      mobile={true}
      style={{ position: 'fixed', borderRadius: mobileFiltersOpened ? '8px' : 0 }}
      toolbarProps={{ style: { flexWrap: 'wrap' } }}
    >
      <HeaderTitle />
      <span className="flex-grow" />
      {isMobile ? <MobileActions /> : <DesktopActions />}
    </StyledPageHeader>
  );
};

const HeaderTitle = () => {
  const { isMobile } = useDeviceInfo();
  const { mobileFiltersOpened } = useHeaderContext();

  if (!isMobile) return null;

  if (mobileFiltersOpened) {
    return <StyledTypography variant="title">Filter by</StyledTypography>;
  }

  return <StyledTypography variant="title">Manage Vehicles</StyledTypography>;
};

const MobileActions = () => {
  const [syncBlueDriverVehicles] = useSyncBlueDriverVehiclesMutation({
    fixedCacheKey: 'bluerdriver-sync'
  });

  const { refreshQuery } = useVehicleListContext();

  const { mobileFiltersOpened } = useHeaderContext();

  const currentUser = useCurrentUser();
  const isLister = currentUser.job_title === 'Lister';

  const refreshList = async () => {
    window.scrollTo({ top: 0, left: 0 });
    if (isLister) {
      await syncBlueDriverVehicles();
    }
    refreshQuery()
  };

  return (
    <>
      {!mobileFiltersOpened && <VinScanButton />}
      {!mobileFiltersOpened && (
        <ButtonBase onClick={refreshList}>
          <Icon style={{ color: '#999999' }}>refresh</Icon>
        </ButtonBase>
      )}
      <FilterButton />
    </>
  );
};

const ActionWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

const DesktopActions = () => {
  const dispatch = useDispatch();

  const { open } = usePoolModalControls();

  const { refreshQuery } = useVehicleListContext();

  const user = useCurrentUser();
  const isSeller = user.role === 'seller';

  const startVehicleUpload = () => {
    dispatch(openVinDialog({ vehicleId: null, type: isSeller ? 'seller-upload' : 'admin-upload' }));
  };

  const resetVehicles = () => {
    refreshQuery();
    window.scrollTo({ top: 0, left: 0 });
  };

  return (
    <ActionWrapper>
      <VinDialog />
      <ButtonBase onClick={resetVehicles}>
        <SyncIcon />
      </ButtonBase>
      {!isSeller && <ActionButton onClick={open}>Vehicle Pool</ActionButton>}
      {!isSeller && <VehiclePoolDialog />}
      <ActionButton onClick={startVehicleUpload}>Upload Vehicle</ActionButton>
      <FilterButton />
    </ActionWrapper>
  );
};

export default HeaderWithContext;
